// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","header":"Modal_header__VdBgK","content":"Modal_content__0gsT8","actions":"Modal_actions__f+o3e"};